//这个是有效的
import React, { Component } from 'react'
import { Route, Routes } from 'react-router-dom'
import Home from "./home"
import EmptyPage from './emptyPage'
import TaskList from './taskList'
import TaskAppealPage from '../views/TaskAppealPage/TaskAppealPage'
import PointsExpandPage from '../views/PointsPage/PointsExpandPage'
import PointsMemberPage from '../views/PointsPage/PointsMemberPage'
import PointsUserPage from '../views/PointsPage/PointsUserPage'
import FinancePage from '../views/FinancePage/FinancePage'

//后管系统进来的后面
import Navigation from './navigation'
export default class Main extends Component {
    render() {
        return (
            <div className='main'>
                <Navigation/>
                <Routes>
                    <Route path='/' Component={Home}></Route> 
                    <Route path='/taskManage/taskList' Component={TaskList}></Route>
                    <Route path='/taskManage/taskAppeal' Component={TaskAppealPage}></Route>
                    <Route path='/pointsManage/pointsExpand' Component={PointsExpandPage}></Route>
                    <Route path='/pointsManage/pointsMember' Component={PointsMemberPage}></Route>
                    <Route path='/pointsManage/pointsUser' Component={PointsUserPage}></Route>
                    <Route path='/financeManage/*' Component={FinancePage}></Route>
                    <Route  path = '/emptyPage' Component={EmptyPage}></Route> 
                 </Routes>
            </div>
        )
    }
}

